export function formatFileSize(bytes) {
    if (bytes === 0) { 
        return "0 Bytes";
    }
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
}

export function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
}

export function determineFileType(fileName) {
    if (!fileName || typeof fileName !== "string") return "";
    const extension = fileName.split('.').pop().toLowerCase();
    return extension ? `.${extension}` : "";
}

export function determineStatusColor(status) {
    if (status === 'completed') return 'success';
    if (status === 'active') return 'warning';
    if (status === 'deleted') return 'danger';
    return 'secondary';
}

// Centralized file type metadata mapping
export const FILE_TYPE_META = {
  image: {
    label: 'Images',
    icon: 'fa fa-file-image',
    color: '#EA4335',
    extensions: ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg']
  },
  pdf: {
    label: 'PDFs',
    icon: 'fa fa-file-pdf',
    color: '#EA4335',
    extensions: ['.pdf']
  },
  document: {
    label: 'Word Documents',
    icon: 'fa fa-file-word',
    color: '#4285F4',
    extensions: ['.doc', '.docx']
  },
  spreadsheet: {
    label: 'Spreadsheets',
    icon: 'fa fa-file-excel',
    color: '#34A853',
    extensions: ['.xls', '.xlsx']
  },
  presentation: {
    label: 'Presentations',
    icon: 'fa fa-file-powerpoint',
    color: '#FBBC05',
    extensions: ['.ppt', '.pptx']
  },
  text: {
    label: 'Text Files',
    icon: 'fa fa-file-alt',
    color: '#5F6368',
    extensions: ['.txt', '.csv']
  },
  archive: {
    label: 'Archives',
    icon: 'fa fa-file-archive',
    color: '#5F6368',
    extensions: ['.zip', '.rar', '.7z', '.iso']
  },
  video: {
    label: 'Videos',
    icon: 'fa fa-file-video',
    color: '#A142F4',
    extensions: ['.mp4', '.mov', '.avi', '.mkv']
  },
  audio: {
    label: 'Audio',
    icon: 'fa fa-file-audio',
    color: '#F4B400',
    extensions: ['.mp3', '.wav', '.ogg']
  },
  code: {
    label: 'Code Files',
    icon: 'fa fa-file-code',
    color: '#4285F4',
    extensions: ['.html', '.css', '.js', '.json', '.xml']
  },
  other: {
    label: 'Other',
    icon: 'fa fa-file',
    color: '#B0BEC5',
    extensions: []
  }
};

function getFileTypeGroup(fileType) {
  const ext = fileType.toLowerCase();
  for (const [group, meta] of Object.entries(FILE_TYPE_META)) {
    if (meta.extensions.includes(ext)) {
      return group;
    }
  }
  return 'other';
}

export function determineFileIcon(fileType) {
  const group = getFileTypeGroup(fileType);
  return FILE_TYPE_META[group].icon;
}

export function determineFileColor(fileType) {
  const group = getFileTypeGroup(fileType);
  return FILE_TYPE_META[group].color;
}

export function getFileTypeLabel(fileType) {
  const group = getFileTypeGroup(fileType);
  return FILE_TYPE_META[group].label;
}

export function extractEmail(sharedId) {
    return sharedId.split(":")[2];
}
